export default __webpack_public_path__ + "static/media/shashankPrakash.b9333dc4.jpg";